import { Skeleton } from "@/components/ui/skeleton";

interface TableSkeletonProps {
  /** Number of placeholder columns per row. */
  columns?: number;
  /** Number of placeholder body rows. */
  rows?: number;
}

/** Content-shaped placeholder that mirrors the new-bar table (header band +
 * divided rows) so first loads settle into the real table without a layout jump. */
export function TableSkeleton({ columns = 4, rows = 5 }: TableSkeletonProps) {
  return (
    <div className="bg-card border-border overflow-hidden rounded-lg border shadow-sm">
      <div className="bg-warm-gray-01 border-border flex items-center gap-4 border-b px-4 py-3">
        {Array.from({ length: columns }).map((_, i) => (
          <Skeleton key={i} className="h-3 w-20" />
        ))}
      </div>
      <div className="divide-border divide-y">
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="flex items-center gap-4 px-4 py-3.5">
            {Array.from({ length: columns }).map((_, c) => (
              <Skeleton key={c} className={c === 0 ? "h-4 w-40" : "h-4 w-24"} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
